/**
 * Порог «посетитель прошёл ≥ 90 % своего пути в квизе» — БРАУЗЕРНОЕ ЗЕРКАЛО
 * серверной формулы (backend/src/analytics/utils/screen-progress.util.ts:
 * `QUIZ90_PROGRESS_THRESHOLD` + `reachedScreenProgress`).
 *
 * Зачем зеркало. Сервер шлёт в рекламную сеть событие `QUIZ_PROGRESS_90`
 * (WEB-2184), браузер шлёт своё — и сеть склеивает их в одну конверсию только
 * при совпадении имени И ключа склейки. Ключ считается от строки вида события,
 * поэтому браузер обязан слать ViewContent на том же факте (взят порог), а не
 * на первом же просмотре экрана: иначе это два разных события, и конверсия
 * считается дважды (находка ревизии Н3, 17.09).
 *
 * Разница в нумерации: сервер получает номер экрана С НУЛЯ (колонка
 * `analytics_events.screen_index`) и считает `(index + 1) / total`; у плеера
 * номер шага идёт С ЕДИНИЦЫ, поэтому здесь `step / total` — то же число.
 * Совпадение самого порога сторожит кросс-тест
 * `playerPixelEvents.funnelKinds.web2181b.test.ts` (читает серверный файл).
 */
export const QUIZ90_PROGRESS_THRESHOLD = 0.9;

/**
 * Взят ли порог на ЭТОМ экране.
 *
 * @param stepNumber номер экрана в пути посетителя, С ЕДИНИЦЫ
 * @param visitorPathTotal длина фактического пути посетителя (WEB-1812)
 */
export function reachedQuizProgress90(
  stepNumber: number,
  visitorPathTotal: number,
): boolean {
  if (!Number.isFinite(stepNumber) || !Number.isFinite(visitorPathTotal)) {
    return false;
  }
  if (visitorPathTotal <= 0) return false;
  return stepNumber / visitorPathTotal >= QUIZ90_PROGRESS_THRESHOLD;
}
